/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/assets/js/global.js":
/*!*********************************!*\
  !*** ./src/assets/js/global.js ***!
  \*********************************/
/***/ (() => {

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    initCustomDropdowns();
    initHideInScrollHeader();
    initCustomEllipsis();
    InjectEllipsis();
  });
  document.addEventListener('nav-is-open', function () {
    initCustomDropdowns();
    initHideInScrollHeader();
  });
  document.addEventListener('nav-is-closed', function () {
    initCustomDropdowns();
    initHideInScrollHeader();
  });
  document.addEventListener('megamenu::loaded', function () {
    initCustomMegamenu();
    initCustomHiddenMegamenu();
  });
  window.addEventListener('resize', function () {
    InjectEllipsis();
  });
  function InjectEllipsis() {
    var elements = document.querySelectorAll('[data-limited-text]');
    elements.forEach(function (element) {
      var wordLimit = element.getAttribute('data-limited-text');
      var mediaLimit = element.getAttribute('data-media-limit');
      if (window.innerWidth <= mediaLimit) {
        var words = element.textContent.split(' ').filter(function (item) {
          return item.trim().length > 0;
        });
        if (words.length > wordLimit) {
          element.textContent = words.slice(0, wordLimit).join(' ') + '...';
        }
      } else {
        element.textContent = element.getAttribute('data-original-text');
      }
    });
  }
  function initCustomEllipsis() {
    document.querySelectorAll('[data-limited-text]').forEach(function (element) {
      element.setAttribute('data-original-text', element.textContent);
    });
  }
  function initCustomHiddenMegamenu() {
    var customMegamenus = document.querySelectorAll('.megamenu-wrapper');
    customMegamenus.forEach(function (customMegamenu) {
      customMegamenu.classList.remove('js-ydm-init-hidden');
    });
  }
  function initCustomMegamenu() {
    var customMegamenus = document.querySelectorAll('.megamenu-wrapper');
    customMegamenus.forEach(function (customMegamenu) {
      var buttonTrigger = customMegamenu.querySelector('button');
      var megamenuBody = customMegamenu.querySelector('.no-js-focus-container');
      buttonTrigger === null || buttonTrigger === void 0 || buttonTrigger.addEventListener('mouseenter', function () {
        if (buttonTrigger) {
          buttonTrigger.click();
          closeAllDropdowns();
        }
      });
      megamenuBody === null || megamenuBody === void 0 || megamenuBody.addEventListener('mouseleave', function () {
        if (buttonTrigger) {
          buttonTrigger.click();
        }
      });
    });
  }
  function initCustomDropdowns() {
    initCommonDropdown();
    initLocalizationDropdown();
  }
  function initCommonDropdown() {
    var dropdowns = document.querySelectorAll('dropdown-menu');
    dropdowns.forEach(function (dropdown) {
      var dropdownTriggers = dropdown.querySelectorAll('.dropdown-trigger');
      dropdownTriggers.forEach(function (dropdownTrigger) {
        var dropdownTriggerButton = dropdownTrigger.querySelector('a');
        var dropdownList = dropdownTrigger.querySelector('ul');
        dropdownTrigger === null || dropdownTrigger === void 0 || dropdownTrigger.addEventListener('click', function () {
          return handleDropdownClick(dropdownTrigger);
        });
        if (window.innerWidth >= 990) {
          dropdownTriggerButton === null || dropdownTriggerButton === void 0 || dropdownTriggerButton.addEventListener('mouseenter', function () {
            return handleDropdownClick(dropdownTrigger);
          });
          dropdownList === null || dropdownList === void 0 || dropdownList.addEventListener('mouseleave', function () {
            return handleDropdownClick(dropdownTrigger);
          });
        }
      });
    });
  }
  function checkIfMegamenuIsOpen() {
    var megamenuTrigger = document.querySelector('.megamenu-wrapper button');
    if ((megamenuTrigger === null || megamenuTrigger === void 0 ? void 0 : megamenuTrigger.getAttribute('aria-expanded')) === 'true') {
      return true;
    }
    return false;
  }
  function toggleMegamenu() {
    var megamenuTrigger = document.querySelector('.megamenu-wrapper button');
    if (megamenuTrigger) {
      megamenuTrigger.click();
    }
  }
  function initLocalizationDropdown() {
    var dropdowns = document.querySelectorAll('dropdown-menu');
    dropdowns.forEach(function (dropdown) {
      var localizationItems = dropdown.querySelectorAll('[data-disclosure-option]');
      var inputLocale = dropdown.querySelector('#LocaleSelector');
      var formLocale = dropdown.querySelector('form');
      localizationItems.forEach(function (localizationItem) {
        localizationItem.addEventListener('click', function () {
          var isoCode = localizationItem.getAttribute('data-value');
          inputLocale.value = isoCode;
          if (formLocale) {
            formLocale.submit();
          }
        });
      });
    });
  }
  function handleDropdownClick(dropdownTrigger) {
    var hiddenChild = dropdownTrigger.querySelector('ul');
    var chevronIcon = dropdownTrigger.querySelector('span');
    if (hiddenChild) {
      hiddenChild.classList.toggle('tw-hidden');
    }
    if (chevronIcon) {
      chevronIcon.classList.toggle('rotate-180');
    }
    closeAllDropdowns(dropdownTrigger);
    if (checkIfMegamenuIsOpen()) {
      toggleMegamenu();
    }
  }
  function closeAllDropdowns(dropdownTriggerClicked) {
    var dropdowns = document.querySelectorAll('dropdown-menu');
    dropdowns.forEach(function (dropdown) {
      var dropdownTriggers = dropdown.querySelectorAll('.dropdown-trigger');
      dropdownTriggers.forEach(function (dropdownTrigger) {
        if (dropdownTriggerClicked !== dropdownTrigger || !dropdownTriggerClicked) {
          var hiddenChild = dropdownTrigger.querySelector('ul');
          var chevronIcon = dropdownTrigger.querySelector('span');
          if (hiddenChild) {
            hiddenChild.classList.add('tw-hidden');
          }
          if (chevronIcon) {
            chevronIcon.classList.remove('rotate-180');
          }
        }
      });
    });
  }
  function initHideInScrollHeader() {
    var hideOnScrollHeader = document.querySelector('.js-site-header--hide-on-scroll');
    var lastScrollY = window.scrollY;
    var threshold = 350;
    window.addEventListener('scroll', function () {
      var currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > threshold) {
        hideOnScrollHeader.style.transform = 'translateY(-100%)';
      } else if (currentScrollY < lastScrollY) {
        hideOnScrollHeader.style.transform = 'translateY(0)';
      }
      lastScrollY = currentScrollY;
    });
  }
})();

/***/ }),

/***/ "./src/assets/scss/global.scss":
/*!*************************************!*\
  !*** ./src/assets/scss/global.scss ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/sticky-cart.scss":
/*!******************************************!*\
  !*** ./src/assets/scss/sticky-cart.scss ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/main-product.scss":
/*!*******************************************!*\
  !*** ./src/assets/scss/main-product.scss ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/collection-list-carousel.scss":
/*!*******************************************************!*\
  !*** ./src/assets/scss/collection-list-carousel.scss ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/global": 0,
/******/ 			"assets/collection-list-carousel": 0,
/******/ 			"assets/main-product": 0,
/******/ 			"assets/sticky-cart": 0,
/******/ 			"assets/global": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshopify_origin_magnesium"] = self["webpackChunkshopify_origin_magnesium"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/collection-list-carousel","assets/main-product","assets/sticky-cart","assets/global"], () => (__webpack_require__("./src/assets/js/global.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/collection-list-carousel","assets/main-product","assets/sticky-cart","assets/global"], () => (__webpack_require__("./src/assets/scss/global.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/collection-list-carousel","assets/main-product","assets/sticky-cart","assets/global"], () => (__webpack_require__("./src/assets/scss/sticky-cart.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/collection-list-carousel","assets/main-product","assets/sticky-cart","assets/global"], () => (__webpack_require__("./src/assets/scss/main-product.scss")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/collection-list-carousel","assets/main-product","assets/sticky-cart","assets/global"], () => (__webpack_require__("./src/assets/scss/collection-list-carousel.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;